import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import BookingPaymentID from '@/App/Booking/Payment/Entity/BookingPaymentID'
import Money from '@/Shared/Entity/Money'
import {
    BookingPaymentStateEnum,
    type IntegrationProviderEnum,
    type BookingPaymentData,
} from '@/Shared/AutoGenerated/Main'

export default class BookingPayment {
    constructor(
        public readonly id: BookingPaymentID,
        public readonly state: BookingPaymentStateEnum,
        public readonly amount: Money,
        public readonly externalId: string,
        public readonly externalViewUrl: string,
        public readonly externalViewText: string,
        public readonly integrationProvider: IntegrationProviderEnum,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getBadgeColor(): 'success' | 'secondary' {
        if (this.state === BookingPaymentStateEnum.Paid) {
            return 'success'
        }

        if (this.state === BookingPaymentStateEnum.Refunded) {
            return 'secondary'
        }

        throw new Error(`Unknown booking payment state ${this.state}`)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: BookingPaymentData | null,
    ): BookingPayment | null {
        if (!entityData) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: BookingPaymentData): BookingPayment {
        return new BookingPayment(
            new BookingPaymentID(entityData.id),
            entityData.state,
            new Money(entityData.amount.value, entityData.amount.currency),
            entityData.externalId,
            entityData.externalViewUrl,
            entityData.externalViewText,
            entityData.integrationProvider,
        )
    }

    static hydrateMultiple(
        entitiesData: BookingPaymentData[],
    ): BookingPayment[] {
        const temp: BookingPayment[] = []

        entitiesData.forEach((entityData) => {
            const entity = this.hydrateSingleOrNull(entityData)

            if (entity === null) {
                return
            }

            temp.push(entity)
        })

        return temp
    }
}
